export const ADMIN_SECTION_CONSTANTS = {
  // Loading State
  LOADING: {
    EMOJI: '🔐',
    MESSAGE: 'Checking authentication...',
  },
} as const;